export default __webpack_public_path__ + "media/images/logo/logo-1tvch-c6795f693a75c3f2167c4e7c839f55c4.svg";